import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { TargetingComponent } from '../../../../../pages/targeting/targeting/targeting.component';

export const targeting: Route = {
  path: 'targeting',
  title: 'nav.network.targeting',
  data: {
    breadcrumb: 'nav.network.targeting',
    icon: SbIcons.targeting,
    id: RoutingID.targeting,
  },
  children: [
    {
      path: '',
      component: TargetingComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
